const a2pIndex = () =>
  import(/* webpackChunkName: 'a2pIndex' */ '@/a2p/Index');

const a2pRegisterCustomer = () =>
  import(/* webpackChunkName: 'a2pRegisterCustomer' */ '@/a2p/components/RegisterCustomer');

const a2pRegisterCustomerLite = () =>
  import(/* webpackChunkName: 'a2pRegisterCustomerLite' */ '@/a2p/components/RegisterCustomerLite');


export default [
  {
    path: '/a2p',
    component: a2pIndex,
    name: 'a2p.index',
    meta: { auth: true },
    redirect: 'a2p-standardbrand-registration',
  },
  {
    path: '/a2p-standardbrand-registration',
    component: a2pRegisterCustomer,
    name: 'a2p.register-customer',
    meta: { auth: true },
  },
  {
    path: '/a2p-litebrand-registration',
    component: a2pRegisterCustomerLite,
    name: 'a2p.register-customer-lite',
    meta: { auth: true },
  },
  {
    path: '/a2p-lowstandardbrand-registration',
    component: a2pRegisterCustomer,
    name: 'a2p.register-customer-low',
    meta: { auth: true },
    props: {
      lowStandard: true,
    },
  },
];
